import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const Privacidad = () => {
  useEffect(() => {
    document.title = "Política de privacidad · PORT'S COLLECTORS";
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid="page-privacidad" className="bg-white min-h-screen">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="back-home"
            className="text-sm text-ink-muted hover:text-navy inline-flex items-center gap-2"
          >
            <ArrowLeft size={16} /> Volver
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-xs uppercase tracking-[0.22em] text-sky font-semibold mb-4">
          Protección de datos
        </div>
        <h1 className="font-display text-4xl lg:text-5xl text-navy leading-tight tracking-tight">
          Política de privacidad
        </h1>

        <div className="mt-10 space-y-8 text-ink-muted leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-navy mb-3">1. Responsable del tratamiento</h2>
            <ul className="space-y-1.5 text-sm bg-surface-alt border border-slate-200 rounded-sm p-5">
              <li><strong className="text-navy">Titular:</strong> PORT&rsquo;S DEBT COLLECTION S.L.</li>
              <li><strong className="text-navy">CIF:</strong> B16935785</li>
              <li><strong className="text-navy">Domicilio:</strong> C/ María de Molina nº 60, 28006 Madrid</li>
              <li><strong className="text-navy">Correo:</strong> abogados@portsdebt.es</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">2. Finalidad</h2>
            <p>
              Los datos personales facilitados a través del formulario de contacto serán tratados
              con la finalidad exclusiva de atender la consulta planteada y, en su caso, prestar
              los servicios profesionales solicitados.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">3. Legitimación</h2>
            <p>
              La base legal del tratamiento es el consentimiento del interesado prestado al enviar
              el formulario, así como, en su caso, la ejecución de un contrato o medidas
              precontractuales.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">4. Conservación de datos</h2>
            <p>
              Los datos se conservarán durante el tiempo necesario para atender la consulta y,
              posteriormente, durante los plazos legalmente exigibles.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">5. Destinatarios</h2>
            <p>
              Los datos no serán cedidos a terceros salvo obligación legal o cuando resulte
              imprescindible para la prestación del servicio (por ejemplo, colaboradores
              profesionales sujetos a deber de confidencialidad).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">6. Derechos</h2>
            <p>
              El usuario puede ejercer sus derechos de acceso, rectificación, supresión, oposición,
              limitación y portabilidad enviando una solicitud a{" "}
              <a href="mailto:abogados@portsdebt.es" className="text-navy underline">
                abogados@portsdebt.es
              </a>
              , adjuntando copia de un documento identificativo.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">7. Cookies</h2>
            <p>
              Esta web utiliza únicamente cookies técnicas necesarias para su correcto
              funcionamiento. No se utilizan cookies con fines publicitarios o de seguimiento.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Privacidad;
